export default "__VITE_ASSET__CBAzUTtB__"